/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfListOfNameValueDto } from "../models/AjaxResponseOfListOfNameValueDto";

import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class AutolineAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getColors(): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/autoline/get-colors",
    });
  }

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getDoors(): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/autoline/get-doors",
    });
  }

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getFuelTypes(): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/autoline/get-fuel-types",
    });
  }

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getMakes(): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/autoline/get-makes",
    });
  }

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getModels({
    makeId,
  }: {
    makeId?: string;
  }): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/autoline/get-models",
      query: {
        makeId: makeId,
      },
    });
  }

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getOptionals(): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/autoline/get-optionals",
    });
  }

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getTransmission(): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/autoline/get-transmission",
    });
  }

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getVersions({
    modelId,
    vehicleYear,
  }: {
    modelId?: string;
    vehicleYear?: number;
  }): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/autoline/get-versions",
      query: {
        modelId: modelId,
        vehicleYear: vehicleYear,
      },
    });
  }
}
